import { z } from "zod";

/** API エラーの共通表現。message は日本語の表示用文言。 */
export const apiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
});
export type ApiError = z.infer<typeof apiErrorSchema>;
